<!-- eslint-disable -->
<template>
  <CommonPages id="total-car-cost-calculator" :class="['total-car-cost-calculator']"
    :titlePrefix="'Total Car Cost Calculator'"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'">
    <div class="total-car-cost-calculator-container">
      <!-- 顶部Banner部分 -->
      <div class="calculator-banner"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="calculator-banner__content">
          <div class="calculator-banner__title">Total Car Cost Calculator</div>
          <div class="calculator-banner__description">
            Get a comprehensive view of your car expenses with our Total Car Cost Calculator. By
            entering details like purchase price, insurance, maintenance, fuel costs, and loan
            terms, you can estimate the true cost of owning a vehicle. This tool helps you make
            informed financial decisions by considering all aspects of car ownership. Start
            calculating to ensure your budget aligns with your automotive needs!
          </div>
          <div class="card-button white-button" @click="navigateToPage('/lenders-for-bad-credits')">
            <div class="button-text">View More</div>
            <svg class="button-arrow" viewBox="0 0 16 12" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
                fill="#1A4048" />
            </svg>
          </div>
        </div>
        <div class="calculator-banner__image">
          <img src="@/assets/total-car-cost-calculator-banner.png" alt="Car Image" />
        </div>
      </div>

      <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_1" ref="ads-cal-1"
        class="ad-width-100 " :ads="adsensConfig?.cal_1" :showDebug="showDebug" />

      <!-- 计算器部分 -->
      <div class="calculator-container"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="loan-details">
          <div class="loan-details__header">Loan Details</div>
          <div class="loan-details__form">
            <div class="form-row">
              <div class="form-group">
                <label>Car Payment</label>
                <div class="input-wrapper">
                  <input type="text" v-model="formData.carPayment" placeholder="$800"
                    @input="validateInput('carPayment')">
                </div>
              </div>
              <div class="form-group">
                <label>Insurance</label>
                <div class="input-wrapper">
                  <input type="text" v-model="formData.insurance" placeholder="$100"
                    @input="validateInput('insurance')">
                </div>
              </div>
              <div class="form-group">
                <label>Gas</label>
                <div class="input-wrapper">
                  <input type="text" v-model="formData.gas" placeholder="$186"
                    @input="validateInput('gas')">
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>Maintenance And Repairs</label>
                <div class="input-wrapper">
                  <input type="text" v-model="formData.maintenance" placeholder="$126"
                    @input="validateInput('maintenance')">
                </div>
              </div>
              <div class="form-group">
                <label>Registration, Fees, Taxes And Miscellaneous</label>
                <div class="input-wrapper">
                  <input type="text" v-model="formData.registration" placeholder="$68"
                    @input="validateInput('registration')">
                </div>
              </div>
              <div class="form-group invisible">
                <!-- 隐藏的占位 -->
                <label>Hidden Field</label>
                <div class="input-wrapper">
                  <input type="text">
                </div>
              </div>
            </div>
            <div class="calculate-btn-wrapper">
              <button class="calculate-btn" @click="calculateExpenses">Calculate</button>
            </div>
          </div>
        </div>

        <AdComponent v-if="deviceType == 'mobile'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_2" ref="ads-cal-2"
          class="ad-width-100 " :ads="adsensConfig?.cal_2" :showDebug="showDebug" />

        <div class="loan-estimate">
          <div class="loan-estimate__header">Your Loan Estimate</div>
          <div class="loan-estimate__content">
            <div class="total-expenses">
              <div class="total-expenses__label">Total Monthly Car Expenses</div>
              <div class="total-expenses__value">{{ totalExpenses }}</div>
            </div>
          </div>
        </div>
      </div>

      <AdComponent v-if="deviceType != 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_1" ref="ads-cal-1"
        class="ad-width-100 pc_padding" :ads="adsensConfig?.cal_1" :showDebug="showDebug" />

      <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_3" ref="ads-cal-3"
        class="ad-width-100 " :ads="adsensConfig?.cal_3" :showDebug="showDebug" />

      <!-- 术语表部分 -->
      <div class="glossary-section"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="glossary-container">
          <div class="section-header">
            <div class="section-title">Glossary of Terms</div>
            <div class="section-divider"></div>
          </div>

          <div class="glossary-items">
            <div class="glossary-item">
              <img src="@/assets/icons/payment-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Car Payment</div>
                <div class="glossary-description">
                  The monthly payment you make toward your auto loan or lease. It includes both
                  principal and interest for loans.
                  <br>
                  Typical Range: Car payments can vary widely based on the vehicle's price, interest
                  rate, and loan term. Generally, they
                  range from $200 to $1,000 or more per month.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/insurance-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Insurance</div>
                <div class="glossary-description">
                  The monthly premium you pay for auto insurance coverage, which protects against
                  financial loss in the event of an
                  accident, theft, or other damage.
                  <br>
                  Typical Range: Insurance costs depend on factors like driving history, vehicle
                  type, and coverage level. Averages range
                  from $50 to $200 per month.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/gas-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Gas</div>
                <div class="glossary-description">
                  The monthly cost of fuel for your vehicle, based on driving habits and fuel
                  efficiency.
                  <br>
                  Typical Range: Gas expenses vary based on fuel prices, vehicle efficiency, and
                  miles driven. Commonly ranges from $100
                  to $300 per month.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/maintenance-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Maintenance and Repairs</div>
                <div class="glossary-description">
                  The cost of regular maintenance (like oil changes and tire rotations) and
                  unexpected repairs.
                  <br>
                  Typical Range: Maintenance costs can vary by vehicle age and condition, typically
                  ranging from $50 to $150 per month.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/registration-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Registration, Fees, Taxes and Miscellaneous</div>
                <div class="glossary-description">
                  Costs associated with vehicle registration, state fees, taxes, and other
                  miscellaneous expenses.
                  <br>
                  Typical Range: These costs depend on state regulations and vehicle type, often
                  ranging from $20 to $100 per month.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 更多计算器部分 -->
      <div class="more-calculators-section"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="more-calculators-container">
          <div class="section-header">
            <div class="section-title">More Calculators</div>
            <div class="section-divider"></div>
          </div>

          <div class="calculators-cards">
            <!-- 汽车贷款计算器卡片 -->
            <div class="calculator-card loan-calculator">
              <div class="calculator-card-image-placeholder" v-if="deviceType != 'mobile'">
                <img src="@/assets/More-3.png" alt="">
              </div>
              <div class="calculator-card-content">
                <div class="calculator-card-title">Auto Loan Calculator</div>
                <div class="calculator-card-image-placeholder" v-if="deviceType == 'mobile'">
                  <img src="@/assets/More-3.png" alt="">
                </div>
                <div class="calculator-card-button"
                  @click="navigateToPage('/auto-loan-calculator')">
                  <div class="button-text">Try it</div>
                  <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" viewBox="0 0 16 12"
                    fill="none">
                    <path
                      d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
                      fill="#1A4048" />
                  </svg>
                </div>
              </div>
            </div>

            <!-- 汽车租赁计算器卡片 -->
            <div class="calculator-card lease-calculator">
              <div class="calculator-card-image-placeholder" v-if="deviceType != 'mobile'">
                <img src="@/assets/More-1.png" alt="">
              </div>
              <div class="calculator-card-content">
                <div class="calculator-card-title">Auto Lease Calculator</div>
                <div class="calculator-card-image-placeholder" v-if="deviceType == 'mobile'">
                  <img src="@/assets/More-1.png" alt="">
                </div>
                <div class="calculator-card-button"
                  @click="navigateToPage('/auto-lease-calculator')">
                  <div class="button-text">Try it</div>
                  <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" viewBox="0 0 16 12"
                    fill="none">
                    <path
                      d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
                      fill="#1A4048" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'

import '@/css/common.scss';

export default {
  name: 'TotalCarCostCalculator',
  components: {
    CommonPages,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      formData: {
        carPayment: '',
        insurance: '',
        gas: '',
        maintenance: '',
        registration: ''
      },
      totalExpenses: '$0',
      showResults: false
    };
  },
  computed: {
    ...mapGetters([
      'adsensConfig',
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'showDebug',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[TotalCarCostCalculator] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[TotalCarCostCalculator] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[TotalCarCostCalculator] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[TotalCarCostCalculator] Component beforeDestroy`);
    }
  },
  methods: {
    calculateExpenses () {
      try {
        // 清理输入值，移除$和,符号
        const cleanCarPayment = this.formData.carPayment.toString().replace(/[$,]/g, '');
        const cleanInsurance = this.formData.insurance.toString().replace(/[$,]/g, '');
        const cleanGas = this.formData.gas.toString().replace(/[$,]/g, '');
        const cleanMaintenance = this.formData.maintenance.toString().replace(/[$,]/g, '');
        const cleanRegistration = this.formData.registration.toString().replace(/[$,]/g, '');

        // 解析为数字
        const carPayment = parseFloat(cleanCarPayment) || 0;
        const insurance = parseFloat(cleanInsurance) || 0;
        const gas = parseFloat(cleanGas) || 0;
        const maintenance = parseFloat(cleanMaintenance) || 0;
        const registration = parseFloat(cleanRegistration) || 0;

        // 计算总月度开支
        const monthlyTotal = carPayment + insurance + gas + maintenance + registration;


        // 格式化结果为货币格式
        const formatCurrency = (value) => {
          return '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        };

        // 更新计算结果
        this.totalExpenses = formatCurrency(monthlyTotal);
        this.showResults = true;
      } catch (error) {
        console.error('计算出错:', error);
        // 如果计算出错，显示默认值
        this.totalExpenses = '$0.00';
      }
    },

    // 导航到其他页面
    navigateToPage (path) {
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        // 如果没有channel参数，直接导航
        this.$router.push(path);
      }
    },

    validateInput (field) {
      // 清理输入值，移除$和,符号
      const cleanValue = this.formData[field].toString().replace(/[$,]/g, '');

      // 检查是否为有效数字
      if (cleanValue !== '') {
        const numValue = parseFloat(cleanValue);

        // 如果输入的数字小于0，则设置为0
        if (numValue < 0 || isNaN(numValue)) {
          this.formData[field] = '0';
        } else {
          // 保持原值，但确保格式正确，并在前面添加$符号
          this.formData[field] = '$' + cleanValue;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.total-car-cost-calculator {
	position: relative;
}

.total-car-cost-calculator-container {
	padding: rem(36) rem(120);

	.detect_deviece_mobile & {
		padding: rem(16);
	}
}

// 顶部Banner样式
.calculator-banner {
	background: linear-gradient(180deg, rgba(218, 161, 13, 1) 0%, rgba(246, 195, 63, 1) 100%);
	border-radius: rem(24);
	padding: 0 rem(36);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: rem(240);
	position: relative;
	margin-bottom: rem(36);
	.card-button {
		background: #ffffff;
		border-radius: rem(100);
		border: rem(1) solid #1a4048;
		padding: rem(12) 0;
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: center;
		width: rem(136);
		height: rem(40);
		cursor: pointer;

		&:hover {
			background: #f5f5f5;
		}
		.button-text {
			color: #1a4048;
			font-size: rem(14);
			line-height: rem(14);
			font-weight: 700;
		}

		.button-arrow {
			width: rem(16);
			height: rem(12);
		}
	}

	&.detect_deviece_mobile {
		flex-direction: column;
		height: auto;
		padding: rem(24) 0 0 0;
		margin-bottom: rem(16);
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		width: rem(520);
		position: relative;

		.detect_deviece_mobile & {
			width: 100%;
			margin-bottom: rem(20);
			padding: 0 rem(24);
		}
	}

	&__title {
		color: #ffffff;
		font-size: rem(32);
		line-height: rem(32);
		font-weight: 900;
		position: relative;
		align-self: stretch;

		.detect_deviece_mobile & {
			font-size: rem(24);
			line-height: rem(28);
		}
	}

	&__description {
		color: #ffffff;
		font-size: rem(14);
		line-height: rem(20);
		font-weight: 400;
		position: relative;
		align-self: stretch;

		.detect_deviece_mobile & {
			font-size: rem(12);
			line-height: rem(18);
		}
	}

	&__image {
		flex-shrink: 0;
		width: rem(516);
		height: rem(240);
		position: relative;
		overflow: visible;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.detect_deviece_mobile & {
			width: 100%;
			height: rem(180);
		}
	}
}

// 计算器容器样式
.calculator-container {
	margin-bottom: rem(36);
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	width: 100%;

	.detect_deviece_mobile & {
		margin-bottom: rem(16);
	}
}

// 贷款详情样式
.loan-details {
	background: var(--theme-primary-light);
	border-radius: rem(24);
	padding: 0 rem(36);
	display: flex;
	flex-direction: column;
	gap: rem(2);
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	position: relative;

	.detect_deviece_mobile & {
		width: 100%;
		padding: 0 rem(16);
	}

	&__header {
		padding: rem(24) 0;
		color: #1a4048;
		text-align: left;
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 700;
		width: 100%;
	}

	&__form {
		width: 100%;
		padding-bottom: rem(24);
	}
}

.form-row {
	display: flex;
	flex-direction: row;
	gap: rem(20);
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	margin-bottom: rem(20);

	.detect_deviece_mobile & {
		flex-direction: column;
	}
}

.form-group {
	display: flex;
	flex-direction: column;
	gap: rem(8);
	flex: 1;

	&.invisible {
		opacity: 0;
		pointer-events: none;

		.detect_deviece_mobile & {
			display: none;
		}
	}

	label {
		color: #1a4048;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		width: 100%;
	}
}

.input-wrapper {
	position: relative;
	width: 100%;
	display: flex;

	input {
		background: #ffffff;
		border-radius: rem(8);
		border: rem(1) solid #1a4048;
		height: rem(48);
		font-size: rem(18);
		line-height: rem(18);
		color: #1a4048;
		font-weight: 500;
		padding: rem(13) rem(20);
		width: 100%;
		box-sizing: border-box;

		&:focus {
			outline: none;
			border-color: var(--theme-primary);
		}
	}
}

.calculate-btn-wrapper {
	padding: rem(24) 0;
	width: 100%;
	display: flex;
}

.calculate-btn {
	background: var(--theme-primary);
	border-radius: rem(100);
	border: none;
	padding: rem(12) rem(32);
	color: #ffffff;
	font-size: rem(20);
	line-height: rem(20);
	font-weight: 700;
	width: 100%;
	height: rem(48);
	cursor: pointer;

	&:hover {
		opacity: 0.9;
	}
}

// 贷款估算样式
.loan-estimate {
	background: #ffffff;
	border-radius: rem(24);
	border: rem(1) solid #e5e7eb;
	padding: 0 rem(36);
	display: flex;
	flex-direction: column;
	gap: rem(6);
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	position: relative;

	.detect_deviece_mobile & {
		width: 100%;
		height: auto;
		padding: 0 rem(20);
	}

	&__header {
		padding: rem(24) 0;
		color: #1a4048;
		text-align: left;
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 700;
		width: 100%;
	}

	&__content {
		padding: 0 0 rem(24) 0;
		display: flex;
		flex-direction: column;
		gap: rem(16);
		width: 100%;
	}
}

.total-expenses {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	width: 100%;

	&__label {
		color: #1a4048;
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 400;
	}

	&__value {
		color: #1a4048;
		font-size: rem(56);
		line-height: rem(56);
		font-weight: 900;
	}
}

// 术语表部分样式
.glossary-section {
	// padding: rem(36) 0;
	margin-bottom: rem(36);
	width: 100%;

	.detect_deviece_mobile & {
		padding: 0;
		margin-bottom: 0;
	}
}

.glossary-container {
	background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	border-radius: rem(24);
	padding: 0 rem(36) rem(36);
	width: 100%;

	.detect_deviece_mobile & {
		padding: 0 rem(16);
	}
}

.section-header {
	padding: rem(24) 0;
	display: flex;
	flex-direction: column;
	gap: rem(20);
	align-items: flex-start;
	justify-content: center;
	height: rem(96);

	.detect_deviece_mobile & {
		height: auto;
		padding: rem(20) 0;
	}
}

.section-title {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(24);
	font-weight: 900;
	text-align: left;

	.detect_deviece_mobile & {
		font-size: rem(20);
		line-height: rem(20);
	}
}

.section-divider {
	background: var(--theme-primary);
	border-radius: rem(100);
	width: rem(36);
	height: rem(4);
}

.glossary-items {
	display: flex;
	flex-direction: column;
	gap: rem(24);
	padding-bottom: rem(36);
}

.glossary-item {
	display: flex;
	flex-direction: row;
	gap: rem(24);
	align-items: flex-start;
	width: 100%;

	.detect_deviece_mobile & {
		// flex-direction: row;
		// gap: rem(12);
	}
}

.glossary-icon {
	flex-shrink: 0;
	width: rem(32);
	height: rem(32);

	.detect_deviece_mobile & {
		width: rem(24);
		height: rem(24);
	}
}

.glossary-content {
	display: flex;
	flex-direction: column;
	gap: rem(8);
	flex: 1;
}

.glossary-term {
	color: #1a4048;
	font-size: rem(14);
	line-height: rem(14);
	font-weight: 900;
}

.glossary-description {
	color: #1a4048;
	font-size: rem(12);
	line-height: rem(16);
	font-weight: 400;
}

// 更多计算器部分样式
.more-calculators-section {
	margin-bottom: rem(72);
	width: 100%;

	.detect_deviece_mobile & {
		// padding: rem(20) 0 rem(40);
		margin-bottom: rem(36);
	}
}

.more-calculators-container {
	background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	border-radius: rem(24);
	padding: 0 rem(36);
	width: 100%;

	.detect_deviece_mobile & {
		padding: 0;
		.section-header {
			padding: rem(24) rem(16);
		}
	}
}

.calculators-cards {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding-bottom: rem(36);

	.detect_deviece_mobile & {
		flex-direction: column;
		gap: rem(36);
		padding-bottom: 0;
	}
}

.calculator-card {
	border-radius: rem(20);
	padding: rem(20);
	display: flex;
	flex-direction: row;
	gap: rem(20);
	align-items: flex-start;
	width: 48%;

	.detect_deviece_mobile & {
		width: 100%;
		flex-direction: column;
		padding: rem(20) rem(19) 0;
	}
}

.loan-calculator {
	background: linear-gradient(-90deg, rgba(85, 148, 243, 1) 0%, rgba(39, 117, 233, 1) 100%);
}

.lease-calculator {
	background: linear-gradient(270deg, #6fe7d1 0%, #19c4a5 100%);
}

.calculator-card-image-placeholder {
	flex-shrink: 0;
	width: rem(300);
	height: rem(160);

	.detect_deviece_mobile & {
		width: 100%;
		height: rem(180);
	}
}

.calculator-card-content {
	padding: rem(12) 0 rem(8);
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	flex: 1;
	height: rem(160);

	.detect_deviece_mobile & {
		padding-top: 0;
		align-items: center;
	}
}

.calculator-card-title {
	color: #ffffff;
	font-size: rem(28);
	line-height: rem(28);
	font-weight: 900;

	.detect_deviece_mobile & {
		font-size: rem(24);
		line-height: rem(24);
		text-transform: capitalize;
		margin-bottom: rem(16);
	}
}

.calculator-card-button {
	background: #ffffff;
	border-radius: rem(100);
	border: rem(1) solid #1a4048;
	padding: rem(12) rem(32);
	display: flex;
	flex-direction: row;
	gap: rem(12);
	align-items: center;
	justify-content: center;
	width: rem(136);
	height: rem(40);
	cursor: pointer;

	&:hover {
		background: #f5f5f5;
	}

	.detect_deviece_mobile & {
		display: flex;
		width: rem(136);
		height: rem(40);
		padding: rem(12) rem(32);
		margin-bottom: rem(-20);
	}
}

.button-text {
	color: #1a4048;
	font-size: rem(16);
	line-height: rem(16);
	font-weight: 700;
}

.button-icon {
	width: rem(16);
	height: rem(12);
}
</style> 